import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Paper,
} from '@mui/material';
import {
  Phone,
  Email,
  LocationOn,
} from '@mui/icons-material';

interface ContactTilesProps {
  title?: string;
  showTitle?: boolean;
}

const ContactTiles: React.FC<ContactTilesProps> = ({ 
  title = "📞 Contact Us", 
  showTitle = true 
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      {showTitle && (
        <Typography variant="h4" component="h2" gutterBottom align="center" sx={{ mb: 3 }}>
          {title}
        </Typography>
      )}
      <Grid container spacing={3} alignItems="stretch">
        <Grid item xs={12} md={4}>
          <Paper sx={{ 
            p: 3, 
            textAlign: 'center', 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-between' 
          }}>
            <Box display="flex" justifyContent="center" mb={2}>
              <Phone sx={{ fontSize: 32, color: 'primary.main' }} />
            </Box>
            <Typography variant="h6" gutterBottom>
              Phone Orders
            </Typography>
            <Typography variant="body1">
              0410 565 781
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Call before 2:30pm the day before
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ 
            p: 3, 
            textAlign: 'center', 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-between' 
          }}>
            <Box display="flex" justifyContent="center" mb={2}>
              <Email sx={{ fontSize: 32, color: 'primary.main' }} />
            </Box>
            <Typography variant="h6" gutterBottom>
              Email
            </Typography>
            <Typography variant="body1">
              orders@newlifefoodbarn.org
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper sx={{ 
            p: 3, 
            textAlign: 'center', 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-between' 
          }}>
            <Box display="flex" justifyContent="center" mb={2}>
              <LocationOn sx={{ fontSize: 32, color: 'primary.main' }} />
            </Box>
            <Typography variant="h6" gutterBottom>
              Visit Us
            </Typography>
            <Typography variant="body1">
              16 Dunkirk Close<br />
              Arundel, QLD 4214
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactTiles;
